@if (Error) {
  <mj-empty-state Variant="error" Title="Couldn't load user management" [Message]="Error"><div actions><button type="button" mjButton variant="primary" (click)="Refresh()">Try again</button></div></mj-empty-state>
} @else if (NoSeason) {
  <mj-empty-state Variant="empty" Title="OEP is between seasons" Message="There is no active OEP season yet. We will email you when your role opens." />
} @else if (!Loading || Tabs.length > 0) {
<section class="oep-um" [attr.aria-busy]="Busy || Loading">
  <div class="oep-um__head">
    <div>
      <h1 class="oep-um__h1">User management</h1>
      <p class="oep-um__sub">{{ SeasonCode }} · search season participants and select any presenter to edit their section, presentation name, or active status.</p>
    </div>
    <div class="oep-um__asof">
      <span>{{ AsOf }}</span>
      <button type="button" mjButton variant="outline" [disabled]="Loading || Busy" (click)="Refresh()">Refresh</button>
    </div>
  </div>

  <mj-tab-nav class="oep-um__tabs" [Tabs]="Tabs" [ActiveKey]="Role" (TabChange)="SelectRole($event)" />

  <p class="oep-um__status" role="status" aria-live="polite" [attr.data-tone]="Status?.Tone">{{ Status?.Text }}</p>

  @if (Record; as rec) {
    <form class="oep-um__panel" (ngSubmit)="SaveChanges()">
      <div class="oep-um__header">
        <div>
          <h2 class="oep-um__h2">{{ rec.Name }}</h2>
          <p class="oep-um__email">{{ rec.Email }}</p>
        </div>
        <div class="oep-um__header-actions">
          <span class="oep-badge" [attr.data-tone]="rec.IsActive ? 'ok' : 'warn'">{{ rec.IsActive ? 'Active' : 'Inactive' }}</span>
          <button type="button" mjButton variant="outline" [disabled]="Busy" (click)="CloseRecord()">Close</button>
        </div>
      </div>

      @if (SelectedActivity; as act) {
        <div class="oep-um__summary">
          <div class="oep-um__field">
            <span class="oep-um__field-label">Progress</span>
            <div>
              <span class="oep-badge oep-um__progress" [attr.data-tone]="act.ProgressTone">{{ act.Progress }}</span>
              @if (act.ProgressNote) { <span class="oep-um__note">{{ act.ProgressNote }}</span> }
            </div>
          </div>
          <div class="oep-um__field">
            <span class="oep-um__field-label">Last seen</span>
            <p class="oep-um__readonly">{{ act.LastSeen }}</p>
          </div>
          <div class="oep-um__field">
            <span class="oep-um__field-label">Visits</span>
            <p class="oep-um__readonly">{{ act.Visits }}</p>
          </div>
        </div>
      }

      <div class="oep-um__fields">
        <div class="oep-um__field">
          <span class="oep-um__field-label">Name</span>
          <p class="oep-um__readonly">{{ rec.Name }}</p>
        </div>

        <div class="oep-um__field">
          <label class="oep-um__field-label" for="oep-um-section">Section</label>
          <select id="oep-um-section" name="section" class="oep-um__select" [(ngModel)]="DraftSectionID" (ngModelChange)="OnDraftChange()" [disabled]="Busy">
            @for (s of Sections; track s.ID) {
              <option [ngValue]="s.ID">{{ s.Label }}</option>
            }
          </select>
        </div>

        <div class="oep-um__field">
          <label class="oep-um__field-label" for="oep-um-title">Presentation name</label>
          <input id="oep-um-title" name="title" type="text" class="oep-um__input" maxlength="500" [(ngModel)]="DraftTitle" (ngModelChange)="OnDraftChange()" [disabled]="Busy" />
        </div>

        <div class="oep-um__field">
          <span class="oep-um__field-label">Draft presentation path</span>
          @if (rec.DraftFile; as draft) {
            <div class="oep-um__file">
              <code class="oep-um__path">{{ draft.ProviderKey }}</code>
              <button type="button" mjButton variant="outline" [disabled]="Busy" (click)="OpenFile('Draft', draft)">Open draft</button>
              @if (BlockedUrl.Draft; as url) {
                <a class="oep-um__fallback" [href]="url" target="_blank" rel="noopener">Open {{ draft.Name }}<span class="oep-sr"> (opens in a new tab)</span></a>
              }
            </div>
          } @else {
            <p class="oep-um__readonly oep-um__readonly--muted">{{ NotUploaded }}</p>
          }
        </div>

        <div class="oep-um__field">
          <span class="oep-um__field-label">Final presentation path</span>
          @if (rec.FinalFile; as final) {
            <div class="oep-um__file">
              <code class="oep-um__path">{{ final.ProviderKey }}</code>
              <button type="button" mjButton variant="outline" [disabled]="Busy" (click)="OpenFile('Final', final)">Open final</button>
              @if (BlockedUrl.Final; as url) {
                <a class="oep-um__fallback" [href]="url" target="_blank" rel="noopener">Open {{ final.Name }}<span class="oep-sr"> (opens in a new tab)</span></a>
              }
            </div>
          } @else {
            <p class="oep-um__readonly oep-um__readonly--muted">{{ NotUploaded }}</p>
          }
        </div>

        <div class="oep-um__field">
          <label class="oep-um__field-label" for="oep-um-active">Status</label>
          <select id="oep-um-active" name="active" class="oep-um__select" [(ngModel)]="DraftIsActive" (ngModelChange)="OnDraftChange()" [disabled]="Busy">
            <option [ngValue]="true">Active (can sign in to OEP)</option>
            <option [ngValue]="false">Inactive (role revoked, presentation canceled)</option>
          </select>
        </div>
      </div>

      <div class="oep-um__actions">
        <button type="button" mjButton variant="outline" [disabled]="Busy" (click)="CloseRecord()">Close</button>
        <button type="submit" mjButton variant="primary" [disabled]="Busy || !HasChanges">Save changes</button>
      </div>
    </form>
  }

  <div class="oep-um__panel oep-um__panel--flush">
    <div class="oep-um__bar">
      <h2 class="oep-um__h2" id="oep-um-people">People</h2>
      <div class="oep-um__controls">
        <mj-page-search class="oep-um__search" Placeholder="Search name, email, section, title or code" [Value]="Search" (ValueChange)="SetSearch($event)" />
        <label class="oep-um__show">
          <span class="oep-um__show-label">Show</span>
          <select #showSelect [value]="Show" (change)="SetShow(showSelect.value)">
            @for (o of ShowChoices; track o.Value) { <option [value]="o.Value" [selected]="o.Value === Show">{{ o.Label }}</option> }
          </select>
        </label>
      </div>
    </div>
    <p class="oep-um__count">{{ CountLine }}</p>
    @if (Shown.length > 0) {
      <table class="oep-um__table oep-um__table--people" role="table" aria-labelledby="oep-um-people">
        <thead role="rowgroup">
          <tr role="row">
            <th scope="col" role="columnheader">Person</th>
            <th scope="col" role="columnheader">Progress</th>
            <th scope="col" role="columnheader">Last seen</th>
            <th scope="col" role="columnheader">Visits</th>
            @if (Role === 'Presenter') { <th scope="col" role="columnheader">Action</th> }
          </tr>
        </thead>
        <tbody role="rowgroup">
          @for (p of Shown; track p.UserID) {
            <tr role="row" [class.oep-um__row--clickable]="Role === 'Presenter'" [class.oep-um__row--selected]="IsSelected(p.UserID)"
              (click)="SelectPerson(p.UserID)">
              <th scope="row" role="rowheader" class="oep-um__who">
                <span class="oep-um__name">{{ p.Name }}</span>
                <span class="oep-um__person-email">{{ p.Email }}</span>
                @if (p.Where) { <span class="oep-um__where">{{ p.Where }}</span> }
                @if (p.Title) { <span class="oep-um__title">{{ p.Title }}</span> }
              </th>
              <td role="cell">
                <span class="oep-um__label" aria-hidden="true">Progress</span>
                <span class="oep-badge oep-um__progress" [attr.data-tone]="p.ProgressTone">{{ p.Progress }}</span>
                @if (p.ProgressNote) { <span class="oep-um__note">{{ p.ProgressNote }}</span> }
              </td>
              <td role="cell"><span class="oep-um__label" aria-hidden="true">Last seen</span>{{ p.LastSeen }}</td>
              <td role="cell"><span class="oep-um__label" aria-hidden="true">Visits</span>{{ p.Visits }}</td>
              @if (Role === 'Presenter') {
                <td role="cell" class="oep-um__cell-action">
                  <button type="button" mjButton variant="outline" [disabled]="Busy" (click)="SelectPerson(p.UserID); $event.stopPropagation()">
                    {{ IsSelected(p.UserID) ? 'Editing' : 'Edit' }}
                  </button>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
      @if (TotalPages > 1) {
        <div class="oep-um__pager">
          <span class="oep-um__pager-info">Page {{ Page }} of {{ TotalPages }}</span>
          <div class="oep-um__pager-btns">
            <button type="button" mjButton variant="outline" [disabled]="Page <= 1" (click)="PrevPage()">Previous</button>
            <button type="button" mjButton variant="outline" [disabled]="Page >= TotalPages" (click)="NextPage()">Next</button>
          </div>
        </div>
      }
    }
  </div>
</section>
} @else {
  <mj-empty-state Variant="empty" Icon="fa-solid fa-spinner" Title="Loading user management" Message="Fetching season participants…" />
}
